if (!customElements.get('cielohuk-featured-brands')) {
  customElements.define('cielohuk-featured-brands', class extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-brand-panel]'));
      this.buttons = Array.from(this.querySelectorAll('[data-brand-target]'));
      if (!this.panels.length) return;

      this.onClick = (event) => {
        const button = event.target.closest('[data-brand-target]');
        if (this.buttons.includes(button)) this.showBrand(button.dataset.brandTarget);
      };
      this.onBlockSelect = (event) => {
        const panel = this.panels.find((item) => item.dataset.brandBlock === event.detail?.blockId);
        if (panel) this.showBrand(panel.id);
      };
      this.onSectionSelect = (event) => {
        if (event.target.contains(this)) this.showBrand(this.panels[0].id);
      };
      this.addEventListener('click', this.onClick);
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:section:select', this.onSectionSelect);
      }
      const initial = window.Shopify?.designMode ? 0 : Math.floor(Math.random() * this.panels.length);
      this.showBrand(this.activeBrand || this.panels[initial].id);
      const controls = this.querySelector('[data-brand-controls]');
      if (controls) controls.hidden = this.panels.length < 2;
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
    }

    showBrand(id) {
      if (!this.panels.some((panel) => panel.id === id)) return;
      this.activeBrand = id;
      this.panels.forEach((panel) => { panel.hidden = panel.id !== id; });
      this.buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.brandTarget === id));
      });
    }
  });
}
